import { BehaviorSubject, Observable } from 'rxjs';

export class SnLayoutAppbarNavButtonReference {
  private readonly _visibleChange$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  get visibleChange$(): Observable<boolean> {
    return this._visibleChange$.asObservable();
  }

  get isVisible(): boolean {
    return this._visibleChange$.value;
  }

  public onDestroy(): void {
    this._visibleChange$.complete();
  }

  public show(): void {
    this.toggleVisibility(true);
  }

  public hide(): void {
    this.toggleVisibility(false);
  }

  public toggleVisibility(visible: boolean = !this.isVisible): void {
    if (this.isVisible !== visible) {
      this._visibleChange$.next(visible);
    }
  }
}
